export default __webpack_public_path__ + "static/media/dropfile.b3f43f29.svg";